var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$route.meta.breadcrumb
    ? _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          !_vm.$route.query.hide
            ? _c(
                "div",
                { staticClass: "fx fx-full menu-left" },
                [
                  _vm.$route.meta.linkStep
                    ? _c(
                        "el-breadcrumb",
                        { attrs: { separator: "/" } },
                        [
                          _vm._l(_vm.breadcrumbMenuns, function (item, index) {
                            return [
                              index < 1
                                ? _c("el-breadcrumb-item", { key: index }, [
                                    _vm._v(_vm._s(_vm.$t(item))),
                                  ])
                                : index + 1 == _vm.breadcrumbMenuns
                                ? _c("el-breadcrumb-item", { key: index }, [
                                    _vm._v(_vm._s(_vm.$t(item))),
                                  ])
                                : _c("el-breadcrumb-item", { key: index }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "javascript:void(0);" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.doClickBreadcrumb(index)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t(item)))]
                                    ),
                                  ]),
                            ]
                          }),
                        ],
                        2
                      )
                    : _c(
                        "el-breadcrumb",
                        { attrs: { separator: "/" } },
                        [
                          _vm._l(
                            _vm.$route.meta.breadcrumb,
                            function (item, index) {
                              return [
                                _c("el-breadcrumb-item", { key: index }, [
                                  _vm._v(_vm._s(_vm.$t(item))),
                                ]),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "breadcrumb-btn" }),
          _vm.showRecommendDialog
            ? _c("newRecommendDialog", {
                ref: "recommendDialog",
                model: {
                  value: _vm.showRecommendDialog,
                  callback: function ($$v) {
                    _vm.showRecommendDialog = $$v
                  },
                  expression: "showRecommendDialog",
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }